






























































import { openModal } from 'mycorems-app-shared';
import HasTaskMixin from '../../components/HasTaskMixin';
import eventBus from '../../messaging/event-bus';
import { AccountLogoUploaded } from '../../messaging/events';
import { Account } from '../../types';
import UploadLogoModal from './UploadLogoModal.vue';
import repository from '../account-repository';

interface Data {
  account: Account|null,
}

export default HasTaskMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    hideNone: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      account: null,
    };
  },
  computed: {
    isXs(): boolean {
      return (this.size === 'xs');
    },
    isSm(): boolean {
      return (this.size === 'sm');
    },
    hasLogo(): boolean {
      return (this.account !== null && this.account.logoUrl !== null);
    },
    cssClass(): string[] {
      return [
        this.hasLogo ? '' : 'account-logo--none',
        `account-logo--${this.size}`,
      ];
    },
    show(): boolean {
      if (this.isLoading) return false;
      if (this.hasLogo) return true;
      return !this.hideNone;
    },
    logoUrl(): string|null {
      if (this.account && this.account.logoUrl) return this.account.logoUrl;
      return null;
    },
  },
  watch: {
    accountId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = repository.find(this.accountId);
      this.task.then((account: Account) => {
        this.account = account;
      });
    },
    upload() {
      const config = {
        parent: this,
        accountId: this.accountId,
        logoUrl: this.logoUrl,
      };
      openModal(UploadLogoModal, config).onOk((logoUrl: string) => {
        if (this.account) {
          this.account.logoUrl = logoUrl;
        }
      });
    },
    onLogoUploaded(event: AccountLogoUploaded): void {
      if (this.account && this.account.id === event.accountId) {
        this.account.logoUrl = event.logoUrl;
      }
    },
  },
  created(): void {
    eventBus.$on(AccountLogoUploaded.eventName, this.onLogoUploaded);
  },
  beforeDestroy(): void {
    eventBus.$off(AccountLogoUploaded.eventName, this.onLogoUploaded);
  },
});
